import * as yup from "yup";

export const TestDriveValidation = yup.object().shape({
  firstname: yup.string().required("Please enter your first name."),
  lastname: yup.string().required("Please enter your last name."),
  email: yup.string().email("Please enter your valid email.").required("Please enter your email."),
  company: yup.string().required("Please enter your company name.").min(3, "Company name must be greater than 3 characters long."),
  phone: yup.string().required("Please enter a phone number.").min(10, "Please enter a valid phone number."),
});
